module.exports = __webpack_public_path__ + "assets/fd6330d01b69f801eb1b127a63427e56.mp3";